module.exports = __webpack_public_path__ + "img/6.0c0e7718.png";